import { takeLatest } from 'redux-saga/effects';

import requestWrapper from 'utils/requestWrapper';


// Individual exports for testing
export default function* mobileLayoutSaga() {
  // See example in containers/HomePage/saga.js
}
